export default __webpack_public_path__ + "static/media/background-login-lg.b9ef0445.png";